import i18n from '@/i18n'
import Index from './index.vue'
import Layout from '../layout.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'

const pathPrefix = '/v-admin/company-admin/custom-company-theme'

const customCompanyThemeRoute = {
  path: `${pathPrefix}`,
  component: Layout,
  meta: {
    permission: ['PREMIUM_COLOR_CUSTOMIZATION'],
    titleI18nKey: 'admin.company.customCompanyTheme.menu',
    menu: {
      labelI18nKey: i18n.t('admin.company.customCompanyTheme.menu'),
      get label () {
        return i18n.t('admin.company.customCompanyTheme.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
    },
    isAllInclude: true,
    breadcrumb: { hidden: true },
    isNewPage: true,
    isRootBreadcrumb: true
  },
  children: [
    {
      path: '',
      component: Index,
      meta: {
        titleI18nKey: 'admin.company.customCompanyTheme.menu'
      }
    }
  ]
}

export default customCompanyThemeRoute
